import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/application/src/app/global-error.tsx");
